// Copyright (c) 2020 WiseTime. All rights reserved.

export const isDevelopmentEnv = () => import.meta.env.MODE === "development"
export const isTestEnv = () => import.meta.env.MODE === "test"

export const iOSWiseTimeUserAgent = "WiseTime iOS"
export const isIosWiseTime = navigator.userAgent === iOSWiseTimeUserAgent
export const isStagingEnv = window.location.hostname === "wisetime.ninja"
// import.meta.env.MODE === "production" is "true" for staging and production,
// we need to distinguish them for correct API keys resolving of third-party libs
// e.g. Stripe, HubSpot etc.
export const isProductionEnv = import.meta.env.MODE === "production" && !isStagingEnv

export const isUSDomain = (): boolean =>
  window.location.hostname.endsWith("wisetime.us")
